const FallCalendar = ({ height = 32, width = 32 }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_2876_10160)">
      <path
        d="M27.4841 27.4841C29.3218 25.6463 29.3217 22.6667 27.484 20.829C25.6462 18.9913 22.6666 18.9913 20.8289 20.8291C18.9911 22.6669 18.9912 25.6465 20.829 27.4842C22.6668 29.322 25.6464 29.3219 27.4841 27.4841Z"
        fill="#FDC8D3"
      />
      <path
        d="M3.13727 10.6665H6.27451V13.8037H3.13727V10.6665ZM9.41175 10.6665H12.549V13.8037H9.41175V10.6665ZM15.6862 10.6665H18.8235V13.8037H15.6862V10.6665ZM21.9607 10.6665H25.098V13.8037H21.9607V10.6665ZM3.13727 16.3135H6.27451V19.4508H3.13727V16.3135ZM9.41175 16.3135H12.549V19.4508H9.41175V16.3135ZM18.6861 19.4508H15.6862V16.3135H18.8235V19.2958M3.13727 21.9606H6.27451V25.0978H3.13727V21.9606ZM9.41175 21.9606H12.549V25.0978H9.41175V21.9606Z"
        fill="#FDC8D3"
      />
      <path
        d="M5.96078 3.13724V2.19606C5.96078 1.32974 6.66309 0.627441 7.52941 0.627441C8.39572 0.627441 9.09803 1.32974 9.09803 2.19606V4.07841C9.09803 4.94473 8.39572 5.64703 7.52941 5.64703M12.8627 3.13724V2.19606C12.8627 1.32974 13.565 0.627441 14.4313 0.627441C15.2977 0.627441 16 1.32974 16 2.19606V4.07841C16 4.94473 15.2977 5.64703 14.4313 5.64703M19.7647 3.13724V2.19606C19.7647 1.32974 20.467 0.627441 21.3333 0.627441C22.1996 0.627441 22.9019 1.32974 22.9019 2.19606V4.07841C22.9019 4.94473 22.1996 5.64703 21.3333 5.64703"
        stroke="#111928"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M28.2352 18.2029V5.01955C28.2352 3.97987 27.3925 3.13721 26.3529 3.13721H2.50982C1.47014 3.13721 0.627472 3.97987 0.627472 5.01955V28.2351C0.627472 29.2748 1.47014 30.1175 2.50982 30.1175H20.0884"
        stroke="#111928"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M28.2352 18.2028V8.15674H0.627472V27.6076H17.8189M24.2412 21.9622L24.1422 24.5362L25.7097 24.5965"
        stroke="#111928"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M29.2588 29.259C32.0766 26.441 32.0766 21.8723 29.2586 19.0545C26.4407 16.2366 21.872 16.2367 19.0541 19.0547C16.2363 21.8726 16.2364 26.4413 19.0543 29.2591C21.8722 32.077 26.441 32.0769 29.2588 29.259Z"
        stroke="#111928"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_2876_10160">
        <rect width="32" height="32" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export default FallCalendar;
